import React from "react";
import {useTranslation} from "react-i18next";

const SpeakerCard = ({speaker, selectedItems, handleItemSelected}) => {
    const {t} = useTranslation();
    const isSelected = selectedItems.find(v => v.id === speaker.id);

    return (
        <div
            key={speaker.id}
            className={`speaker_card gutter-b mx-2 p-3 rounded card shadow ${isSelected ? "selected" : ""}`}
            onClick={() => {
                if (isSelected) {
                    const removeSelected = selectedItems.filter(v => v.id !== speaker.id);
                    if (removeSelected.length) handleItemSelected(removeSelected);
                } else {
                    handleItemSelected([...selectedItems, speaker]);
                }
            }}
        >
            <div className="d-flex flex-column w-100 h-100 justify-content-between">
                <div
                    className="w-60px h-60px mx-auto my-4 rounded-circle border border-gray shadow bg_image_cover"
                    style={{
                        backgroundImage: `url(${speaker.media_url || "/media/avatars/dummy-avatar.jpg"})`,
                    }}
                />
                <div className="d-flex flex-column w-100">
                    <h5 className="position-relative mb-2 w-100 text-dark font-weight-bold elipsis_2lines">
                        {speaker.name}
                    </h5>
                    <p className="text-muted font-size-sm m-0">
                        {speaker.appearances
                            ? `${t("MODAL.SPEAKERS_SELECTOR.APPEARANCES", {count: speaker.appearances})}${
                                  speaker.appearances > 1 ? "s" : ""
                              }`
                            : null}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SpeakerCard;
